import {isArray} from 'lodash'
import moment from 'moment';

const helper = {};

/**
 * @description 检查一个对象是否有子元素
 * @param {Object} item 检查的对象
 * @param {String} keyname 子元素的 keyname
 */
helper.hasChildren = function (item = {}, keyname = 'children') {
    return item[keyname] && isArray(item[keyname]) && item[keyname].length > 0
}
/**
 * 对table列中的日期格式化为 "YYYY-MM-DD"
 * @param row
 * @param column
 * @param cellValue
 * @param index
 * @returns {string}
 */
helper.tableColumnDateFormat = function(row, column, cellValue, index){
  if (cellValue == undefined) {
    return "";
  }
  return moment(cellValue).format("YYYY-MM-DD");
}

export default helper;
